/**
 * Centralised UI copy — every visible string lives here so we can lint /
 * localise without grepping JSX. Adapted from `Loveable v1/src/content/ui.ts`
 * with the FontAwesome icon imports stripped (this build uses lucide-react
 * inline at the use site).
 *
 * Phase 5a Slice 0 lands the auth-related blocks. Slice 1 expands with the
 * full HudHeader chrome (hudHeader / keyboardShortcuts / accessibility /
 * navigation). Later slices add the rest.
 */

// ── Login page ───────────────────────────────────────────────────────────
export const login = {
  title:               "XAES PHASE ZERO",
  // Plain action language — sci-fi chrome stays in the wordmark/orb,
  // not in the instruction the operator has to follow.
  subtitle:            "Sign in to continue",
  usernamePlaceholder: "Username",
  passwordPlaceholder: "Access code",
  submitLabel:         "SIGN IN",
  errorMessage:        "Invalid credentials. Access denied.",
  statusLine:          "Ready to sign in",
  logoutLabel:         "LOGOUT",
  // Managed-auth mode — single CTA that redirects to the hosted login UI.
  // Copy stays IdP-agnostic (no product / MFA jargon on this screen).
  ssoSubmitLabel:      "SIGN IN",
  ssoBusyLabel:        "OPENING SIGN-IN…",
  ssoHint:             "You'll continue on a secure sign-in page",
};

// ── User Management modal (facilitator only) ─────────────────────────────
export const userManagement = {
  triggerLabel:       "MANAGE CREW",
  modalTitle:         "CREW ROSTER",
  modalSubtitle:      "Crew members",
  crewTab:            "CREW",
  clientsTab:         "CLIENTS",
  nameLabel:          "Name",
  usernameLabel:      "Username",
  passwordLabel:      "Password",
  roleLabel:          "Role",
  affiliationLabel:   "For",
  affiliationDxc:     "DXC",
  affiliationClient:  "Client",
  affiliationFilterAll: "All",
  addButton:          "ADD",
  removeConfirm:      "Remove?",
  emptyRoster:        "No crew members.",
  duplicateError:     "Username already exists.",
  resetPasswordLabel: "RESET",
  newPasswordHint:    "New password",
  closeLabel:         "CLOSE",
  managedSyncHint:    "",
  clientUserHint:     "",
  pendingTitle:       "Pending",
  pendingHint:        "",
  pendingBadge:       "PENDING",
  approveButton:      "APPROVE",
  pendingEmpty:       "",
};

// ── Manage Workshop modal (power-user content overrides) ─────────────────
export const workshopOverrideEditor = {
  triggerLabel:    "MANAGE WORKSHOP",
  modalTitle:      "MANAGE WORKSHOP",
  modalSubtitle:   "Edit default or custom client content per workshop. Saved for everyone.",
  resetAll:        "Reset all",
  resetAllConfirm: "Reset every section?",
};

// ── HudHeader (used by Slice 1) ──────────────────────────────────────────
export const hudHeader = {
  siteTitle:        "XAES · Mission Control",
  siteTitleShort:   "XAES",
  sessionEndsLabel: "Session ends",
  activeLabel:      "ACTIVE",
  backLabel:        "Mission Control",
};

// ── Power User modal ─────────────────────────────────────────────────────
export const powerUser = {
  modalTitle:       "RESTRICTED ACCESS",
  modalSubtitle:    "Enter operator passphrase to unlock power-user mode.",
  inputPlaceholder: "Passphrase...",
  submitLabel:      "AUTHENTICATE",
  cancelLabel:      "ABORT",
  errorMessage:     "Invalid passphrase. Access denied.",
  unlockedBadge:    "POWER USER",
};

// ── Keyboard shortcuts overlay (? key) ──────────────────────────────────
export const keyboardShortcuts = {
  triggerLabel:      "?",
  triggerTitle:      "Keyboard shortcuts",
  overlayTitle:      "KEYBOARD SHORTCUTS",
  landingHeading:    "Mission Control",
  workshopHeading:   "Workshop HUD",
  globalHeading:     "Global",
  escDeselect:       "Deselect workshop / go to overview",
  escBack:           "Return to Mission Control",
  numSelectWorkshop: "Select workshop 1–8",
  numSelectPanel:    "Select workshop 1–8",
  numSelectNav:      "Esc to clear focus",
  questionMark:      "Toggle this help overlay",
  repositorySearch:  "Open Repository — search & browse",
  closeLabel:        "Press Escape or ? to close",
};
